(function () {
    angular.module('components.sort', [])
        .directive('sort', sort);
    function sort() {
        var directive = {
            scope: {
                sorters: '=?',
                ascending: '=?'
            },
            replace: true,
            restrict: 'E',
            require: 'ngModel',
            templateUrl: '/angular/components/sort/sort.html',
            link: link
        };
        return directive;
        function link(scope, element, attr, ngModel) {
            if (scope.order === undefined)
                scope.order = false;
            if (!scope.sorters) {
                scope.sorters = [{
                    label: 'Popular',
                    value: 'popular',
                    active: true
                }, {
                    label: 'Recent',
                    value: 'recent'
                }];
            }
            for (var i = 0; i < scope.sorters.length; i++)
                scope.sorters[i].ascending = scope.order;
            var prevIndex = 0;

            function updateState(index) {
                var current = scope.sorters[index];
                if (index !== prevIndex) {
                    scope.sorters[prevIndex].active = false;
                    prevIndex = index;
                    current.active = true;
                }
            }

            scope.toggle = function (index) {
                var current = scope.sorters[index];
                var noChange = index === prevIndex;
                updateState(index);
                if (noChange)
                    current.ascending = !current.ascending;
                ngModel.$setViewValue(current.value + ':' + (current.ascending ? 'asc' : 'desc'));
            }

            scope.ascend = function (index) {
                var current = scope.sorters[index];
                updateState(index);
                current.ascending = true;
                ngModel.$setViewValue(current.value + ':asc');
            }

            scope.descend = function (index) {
                var current = scope.sorters[index];
                updateState(index);
                current.ascending = false;
                ngModel.$setViewValue(current.value + ':desc');
            }

            var cur = scope.sorters[0];
            ngModel.$setViewValue(cur.value + ':' + (cur.ascending ? 'asc' : 'desc'));
        }
    }
})();